module.exports = __webpack_public_path__ + "static/media/intel_logo.29152cf7.jpg";